import { Component } from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';
import { logger } from '../utils/logger';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('[PolkDesQ] Component crash:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="flex items-center justify-center h-full min-h-[300px]"
          style={{ background: 'var(--pd-bg)' }}
        >
          <div className="text-center max-w-sm px-6">
            <div
              className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center mb-4"
              style={{ background: 'var(--pd-crimson-soft)' }}
            >
              <AlertTriangle className="w-6 h-6" style={{ color: 'var(--pd-crimson)' }} />
            </div>
            <h3
              className="text-[15px] font-semibold mb-1.5"
              style={{ color: 'var(--pd-text)' }}
            >
              Something went wrong
            </h3>
            <p
              className="text-[12px] mb-5"
              style={{ color: 'var(--pd-muted)', lineHeight: 1.6 }}
            >
              {this.props.message || 'This section encountered an error. Your data is safe.'}
            </p>
            <button
              data-testid="error-boundary-retry"
              onClick={this.handleRetry}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-[12px] font-semibold text-white transition-all"
              style={{ background: 'var(--pd-focus)' }}
            >
              <RefreshCw className="w-3.5 h-3.5" />
              Retry
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
